<p>Loading...</p>



<app-csn-popup [feature]="collectionNotAvailableInShareringFeature" [title]="title" [body]="body" (emptyCollectionPopupEmit)="emptyCollectionPopupClose()"></app-csn-popup>